import { inject, Injectable } from '@angular/core';
import { getBrowserCultureLang, Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import config, { availableLangs, AvailableLangs } from '../model/translaco.config';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoaderService implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
  public static get defaultCultureLang(): AvailableLangs {
    const browserLanguage = this.getBrowserCultureLang()?.split(/[_-]/)[0];
    const isAvailableLang = (lang: string | undefined): lang is AvailableLangs =>
      availableLangs.includes(lang as AvailableLangs);

    return isAvailableLang(browserLanguage) ? browserLanguage : (config.defaultLang as AvailableLangs) ?? 'en';
  }

  static readonly getBrowserCultureLang = getBrowserCultureLang;
}
